module.exports = __webpack_public_path__ + "media/St 4-charging station-hint.ec91374f.wav";